import { global } from "../../constants";

export const data = {
  
    banner: {
    base: "服务",
    background: global.banner + "administrative-processes.webp",
    title: "行政流程",
    crumb: "行政流程",
  },

  icon: "fa-solid fa-clipboard-list",
  shortDescription:
    "为船对船（STS）操作设计、控制和执行关键行政流程，确保安全、高效并符合OCIMF标准。",
  title: "行政流程",
  features: {
    title: "STS服务中的关键行政流程",
    deliverables: "交付物",
    reqDocuments: "所需文件",
    subtitle:
      "规划、组织、指挥和控制一体化，服务于船对船（STS）转运操作的运营管理与国际合规。",
    description: `STS服务需要一个结合物流效率与国际合规（OCIMF/ISGOTT）的强大行政体系。我们的方法论基于六大关键流程，确保每次操作的持续性、风险管控和文件可追溯性。`,
    viewDetail: "查看详情",
    feats: [
      {
        key: "planificacion_logistica",
        title: "规划运营与物流能力",
        summary:
          "对人力、技术和物资资源进行战略评估与规划，确保每次STS操作的可用性与安全性。",
        details:
          "我们制定能力计划，包括支援船舶、防护装置、软管和应急设备的分配。涵盖转运区域风险分析、气象研究、港口许可审核，以及POAC/Mooring Master的休息与可用性规划。并对场地和承包商进行尽职调查，确保合规与高效。",
        deliverables: [
          "STS运营能力计划",
          "场地与设备风险评估",
          "关键人力资源可用性报告"
        ],
        requiredDocs: [
          "STS操作主计划",
          "设备与船舶证书",
          "人员可用性与轮换记录"
        ],
        icon: "fa-solid fa-anchor",
        image: global.services + "administrative_processes/1.webp",
      },
      {
        key: "organizacion_rrhh",
        title: "组织与规范专业团队",
        summary:
          "明确的层级结构与专业海事及应急人才管理，确保操作协调。",
        details:
          "我们设计功能型组织架构，明确STS链条中的职责：POAC、船长、安全官、操作员及危机团队。人力资源管理（HRM）包括STCW证书核查、有效期管理、操作经验记录及定期培训计划。目标是确保能力、可追溯性与事件响应。",
        deliverables: [
          "结构与授权手册",
          "STCW证书及POAC经验记录",
          "年度培训与演练计划"
        ],
        requiredDocs: [
          "关键人员证书",
          "以往操作日志",
          "培训与评估记录"
        ],
        icon: "fa-solid fa-users-gear",
        image: global.services + "administrative_processes/2.webp",
      },
      {
        key: "control_normativo",
        title: "管控合规与文件管理",
        summary:
          "每次STS操作前进行全面文件审核，确保符合海事与安全法规。",
        details:
          "我们设立文件管理单元，验证船舶、船员及货物证书（MSDS、COA、DOC、SMC、ISM等）。出发前进行数字化审核，确保可追溯性、一致性及符合OCIMF/ISGOTT指南。此管控可降低处罚、拒绝或操作延误风险。",
        deliverables: [
          "STS文件清单（操作前）",
          "数字化合规审核",
          "版本控制与可追溯系统"
        ],
        requiredDocs: [
          "船舶与船员证书",
          "货物安全文件（MSDS）",
          "ISM/ISPS手册与记录"
        ],
        icon: "fa-solid fa-file-shield",
        image: global.services + "administrative_processes/3.webp",
      },
      {
        key: "direccion_operacional",
        title: "指挥运营与安全执行",
        summary:
          "POAC与船长实时协调，确保联合操作计划的安全执行。",
        details:
          "STS操作期间，采用OCIMF官方检查表作为管控与验证工具。指挥包括船舶间有效沟通、气象监控、压力/流量参数核查，并有权在不安全条件下（风浪、泄漏或溢出）暂停操作。",
        deliverables: [
          "联合STS操作计划",
          "POAC意见执行报告",
          "检查表与气象条件记录"
        ],
        requiredDocs: [
          "已批准的操作计划",
          "现行OCIMF/STS检查表",
          "POAC日志与沟通报告"
        ],
        icon: "fa-solid fa-compass-drafting",
        image: global.services + "administrative_processes/4.webp",
      },
      {
        key: "emergencias_contingencias",
        title: "应急与突发事件响应管理",
        summary:
          "针对STS操作中的海事事故、泄漏或紧急情况，制定正式响应协议。",
        details:
          "我们制定并培训应急预案（SOPEP、VRP），实现分级激活并与海事主管部门即时沟通。包括与海军、保险公司及应急响应企业的合作协议。定期演练提升人员准备度和应急流程效率。",
        deliverables: [
          "STS应急响应计划（SOPEP/VRP）",
          "沟通与指挥链手册",
          "演练与评估记录"
        ],
        requiredDocs: [
          "现行SOPEP/VRP计划",
          "响应单位合同",
          "联系人清单与应急协议"
        ],
        icon: "fa-solid fa-triangle-exclamation",
        image: global.services + "administrative_processes/5.webp",
      },
      {
        key: "auditoria_mejora",
        title: "持续改进与财务管理审计",
        summary:
          "年度运营与财务绩效监控，融合质量管控、成本与合规。",
        details:
          "我们依据OCIMF指南实施绩效审计和STS流程年度回顾。财务方面，审查会计透明度、安全、维护与保险成本，并整合至ERP系统。这样可发现持续改进机会，并以合规投资作为运营风险缓释依据。",
        deliverables: [
          "年度运营绩效报告",
          "STS财务与合规审计",
          "持续改进行动计划"
        ],
        requiredDocs: [
          "STS会计与成本记录",
          "事故或发现历史",
          "以往OCIMF或内部审计"
        ],
        icon: "fa-solid fa-chart-line",
        image: global.services + "administrative_processes/6.webp",
      },
    ],
  },
  ctaText: "申请STS流程咨询",
  ctaLink: "/contact?service=administrative-processes-sts",
};